jQuery.extend(jQuery.fn.dataTable.ext.type.order, {
    "fecha-pre": function (date) {
        var parts = date.split('/');
        return new Date(parts[2], parts[1] - 1, parts[0]).getTime();
    },
    "fecha-asc": function (a, b) {
        return a - b;
    },
    "fecha-desc": function (a, b) {
        return b - a;
    }
});
$(".mayusculas").on('keyup',function(){
    this.value = this.value.toUpperCase();
});
$(".tabla-pagos").DataTable({
    dom: '<"d-flex justify-content-end"B><"col-md-6 p-0 my-3 float-end">rt',
    "columnDefs": [
        { "type": "num", "targets": 0 },
        { type: 'fecha', targets: 1 },
        { type: 'num-fmt', targets: 7 }
    ],
    buttons: [
        'excel',
        {
            extend: 'pdfHtml5',
            exportOptions: {
                columns: ':not(:last-child)'
            },
            customize: function (doc) {
                doc.defaultStyle.fontSize = 10;
                var total = 0;
                var columnIndex = 7;
                doc.content[1].table.body.forEach(function(row, index) {
                    if (index > 0) { // Skip header row
                        var montoText = row[columnIndex].text;
                        var montoValue = parseFloat(montoText.replace('$', '').replace(/,/g, '')); // Remove $ and commas, then convert to float
                        if (!isNaN(montoValue)) {
                            total += montoValue;
                        }
                    }
                });
                var totalRow = new Array(doc.content[1].table.body[0].length).fill('');
                totalRow[columnIndex -1] = 'Total:';
                totalRow[columnIndex ] = '$' + total.toFixed(2);
                doc.content[1].table.body.push(totalRow);
            }
        }
    ],
    language: {
        url: url_base+'/vendor/datatables/spanish.json'
    },
    order: [[0, 'desc']],
});

$(".tabla-ordenes").DataTable({
    dom: '<"d-flex justify-content-end"B><"col-md-6 p-0 my-3 float-end">rt',
    "columnDefs": [
        { "type": "num", "targets": 0 },
        { type: 'fecha', targets: 2 },
        { type: 'num-fmt', targets: [7,8,9] }
    ],
    buttons: [
        'excel', 'pdf'
    ],
    language: {
        url: url_base+'/vendor/datatables/spanish.json'
    },
    order: [[0, 'desc']],
});
document.addEventListener('livewire:load', function () {
    Livewire.on('tablaPagos', function() {
        // Tu fragmento de JavaScript aquí
        $(".tabla-pagos").DataTable({
            dom: '<"d-flex justify-content-end"B><"col-md-6 p-0 my-3 float-end">rt',
            "columnDefs": [
                { "type": "num", "targets": 0 },
                { type: 'fecha', targets: 1 },
                { type: 'num-fmt', targets: 7 }
            ],
            buttons: [
                'excel',
                {
                    extend: 'pdfHtml5',
                    exportOptions: {
                        columns: ':not(:last-child)'
                    },
                    customize: function (doc) {
                        doc.defaultStyle.fontSize = 10;
                        var total = 0;
                        var columnIndex = 7;
                        doc.content[1].table.body.forEach(function(row, index) {
                            if (index > 0) { // Skip header row
                                var montoText = row[columnIndex].text;
                                var montoValue = parseFloat(montoText.replace('$', '').replace(/,/g, '')); // Remove $ and commas, then convert to float
                                if (!isNaN(montoValue)) {
                                    total += montoValue;
                                }
                            }
                        });
                        var totalRow = new Array(doc.content[1].table.body[0].length).fill('');
                        totalRow[columnIndex -1] = 'Total:';
                        totalRow[columnIndex ] = '$' + total.toFixed(2);
                        doc.content[1].table.body.push(totalRow);
                    }
                }
            ],
            language: {
                url: url_base+'/vendor/datatables/spanish.json'
            },
            order: [[0, 'desc']],
        });
        // Puedes añadir cualquier código JavaScript que desees ejecutar
    });

    Livewire.on('tablaOrdenes', function() {
        // Tu fragmento de JavaScript aquí
        $(".tabla-ordenes").DataTable({
            dom: '<"d-flex justify-content-end"B><"col-md-6 p-0 my-3 float-end">rt',
            "columnDefs": [
                { "type": "num", "targets": 0 },
                { type: 'fecha', targets: 2 },
                { type: 'num-fmt', targets: [7,8,9] }
            ],
            buttons: [
                'excel', 'pdf'
            ],
            language: {
                url: url_base+'/vendor/datatables/spanish.json'
            },
            order: [[0, 'desc']],
        });
        // Puedes añadir cualquier código JavaScript que desees ejecutar
        $(".btn-turnar-ordenes").addClass('disabled');
        $('input[name="ordenesEstatus[]"]').change(function(){
            var cantidadSeleccionada = $('input[name="ordenesEstatus[]"]:checked').length;
            if(cantidadSeleccionada){
                $(".btn-turnar-ordenes").removeClass('disabled');
            }else{
                $(".btn-turnar-ordenes").addClass('disabled');
            }
        });
    });
});
$(".tabla-datatable").DataTable({
    dom: '<"d-flex justify-content-between"lB><"col-md-6 p-0 my-3 float-end"f>rtip',
    "columnDefs": [
        { "type": "num", "targets": 0 }
    ],
    buttons: [
        'excel', 'pdf'
    ],
    language: {
        url: url_base+'/vendor/datatables/spanish.json'
    },
    order: [[0, 'desc']],
});
$(".tabla-datatable-order-false").DataTable({
    dom: '<"d-flex justify-content-between"lB><"col-md-6 p-0 my-3 float-end"f>r<"table-responsive"t>ip',
    "columnDefs": [
        { "type": "num", "targets": 0 }
    ],
    buttons: [
        'excel', 'pdf'
    ],
    language: {
        url: url_base+'/vendor/datatables/spanish.json'
    },
    "pageLength": 15,
    "ordering": false
});
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
})
// $(document).ready(function() {
//     $(window).keydown(function(event){
//         if(event.keyCode == 13) {
//             event.preventDefault();
//             return false;
//         }
//     });
// });

toTitleCase = function (e) {
    e.value = e.value.replace(
        /\w\S*/g,
        function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    );
}

firstUpperCase = function (e) {
    const str = e.value;
    e.value = str.charAt(0).toUpperCase() + str.slice(1);
}
if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {

}

$(".telefonos").mask("999-999-99-99",{placeholder:"###-###-##-##"});
$(".edad").mask("99",{placeholder:"##"});

$('.numeric').numeric ( { allowEmpty:true, live:true }, function ( val ) {
    //console.log ( $('#sancionanios').val() );
});

$(".enteros").on('keypress',function(event){
    return event.charCode >= 48 && event.charCode <= 57;
});